export interface GetStorageListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetStorageListPagingAndFilterResponseData
}

export interface GetStorageListPagingAndFilterResponseData {
    items: GetStorageListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetStorageListPagingAndFilterResponseItem {
    storageId: string
    companyId: string
    code: string
    baseStorageId: string
    phone1: string
    email: string
    storageTypeId: any
    palletCapacity: number
    volumeCapacity: number
    isCustomActive: boolean
    baseStorageName: string
    baseStorageCode: string
    storageTypeName: any
    storageAreas: GetStorageListPagingAndFilterResponseStorageArea[]
    storageShelfs: GetStorageListPagingAndFilterResponseStorageShelf[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetStorageListPagingAndFilterResponseStorageArea {
    storageAreaId: string
    storageId: string
    name: string
    storageAreaTypeId: string
    isCustomActive: boolean
    storageAreaTypeName: string
}

export interface GetStorageListPagingAndFilterResponseStorageShelf {
    storageShelfId: string
    storageId: string
    address: string
    storageShelfTypeId: string
    corridor: string
    column: string
    floor: string
    level: string
    isCustomActive: boolean
    storageShelfTypeName: string
}

export const initialGetStorageListPagingAndFilterResponseData: GetStorageListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}